import { isValidSolanaAddress } from "@rozoai/intent-common";
import { isAddress } from "viem";
var BASE58_ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
/**
 * Number of bytes a base58 string decodes to, or null when it contains a
 * character outside the base58 alphabet.
 */
var base58DecodedLength = function (value) {
    var leadingZeros = 0;
    while (leadingZeros < value.length && value[leadingZeros] === "1") {
        leadingZeros++;
    }
    var bytes = []; // little-endian
    for (var _i = 0, _a = value.slice(leadingZeros); _i < _a.length; _i++) {
        var char = _a[_i];
        var digit = BASE58_ALPHABET.indexOf(char);
        if (digit < 0)
            return null;
        var carry = digit;
        for (var i = 0; i < bytes.length; i++) {
            carry += bytes[i] * 58;
            bytes[i] = carry & 0xff;
            carry >>= 8;
        }
        while (carry > 0) {
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    return leadingZeros + bytes.length;
};
/** A Solana account address: base58 that decodes to exactly 32 bytes. */
export var isSolanaAddress = function (value) {
    var trimmed = value.trim();
    if (trimmed !== value || trimmed.length < 32 || trimmed.length > 44) {
        return false;
    }
    return base58DecodedLength(trimmed) === 32;
};
/** An EVM account address (0x + 40 hex, checksum enforced when mixed case). */
export var isEvmAddress = function (value) { return isAddress(value); };
/**
 * A Solana wallet address a withdrawal can be paid to: a valid 32-byte key
 * that is also on the ed25519 curve. Program-derived addresses (off-curve) are
 * rejected, matching the payment stack's own validator.
 */
export var isSolanaWalletAddress = function (value) {
    if (!isSolanaAddress(value))
        return false;
    try {
        return isValidSolanaAddress(value);
    }
    catch (_a) {
        return false;
    }
};
